<template>
  <div class="dep-create">
    <div class="dep-create-steps-desktop">
      <el-steps :active="currentStep" finish-status="success">
        <el-step :title="stepLabel[0]"></el-step>
        <el-step :title="stepLabel[1]"></el-step>
        <el-step :title="stepLabel[2]"></el-step>
      </el-steps>
    </div>
    <div class="dep-create-steps-mobile">
      <div class="dep-create-steps-mobile__container">
        <div
          v-if="currentStep > 0"
          class="dep-create-steps-mobile__step dep-create-steps-mobile__step--first"
        >
          <div class="dep-create-steps-mobile__step-number">
            <i class="el-step__icon-inner is-status el-icon-check"></i>
          </div>
          <div class="dep-create-steps-mobile__step-label">{{ stepLabel[currentStep - 1]}}</div>
        </div>
        <div class="dep-create-steps-mobile__step dep-create-steps-mobile__step--curent">
          <div class="dep-create-steps-mobile__step-number">
            <span>{{ currentStep + 1}}</span>
          </div>
          <div class="dep-create-steps-mobile__step-label">{{ stepLabel[currentStep]}}</div>
        </div>
        <div
          v-if="currentStep < 2"
          class="dep-create-steps-mobile__step dep-create-steps-mobile__step--last"
        >
          <div class="dep-create-steps-mobile__step-number">
            <span>{{ currentStep + 2}}</span>
          </div>
          <div class="dep-create-steps-mobile__step-label">{{ stepLabel[currentStep + 1]}}</div>
        </div>
        <div
          v-bind:class="{ hide: currentStep == 0 }"
          class="dep-create-steps-mobile__line dep-create-steps-mobile__line--left"
        ></div>
        <div
          v-bind:class="{ hide: currentStep == 2 }"
          class="dep-create-steps-mobile__line dep-create-steps-mobile__line--right"
        ></div>
      </div>
    </div>
    <div class="dep-create-form">
      <first-step
        :parent="parent"
        v-show="currentStep === 0"
        @nextStep="next"
        @prevStep="prev"
        @getData="setData"
        @setPageTitle="setPageTitle"
        @setOrgParent="setOrgParent"
        ref="firstStep"
      ></first-step>
      <second-step
        v-show="currentStep === 1"
        @nextStep="next"
        @prevStep="prev"
        @getData="setData"
        ref="secondStep"
      ></second-step>
      <third-step
        v-if="currentStep === 2 && depData"
        @sendData="sendData"
        @prevStep="prev"
        :depData="depData"
        :orgParent="orgParent"
        ref="fourthStep"
      ></third-step>
    </div>
  </div>
</template>
<script>
import firstStep from './steps/step_1.vue'
import secondStep from './steps/step_2.vue'
import thirdStep from './steps/step_3.vue'

export default {
  components: {
    firstStep,
    secondStep,
    thirdStep,
    // fourthStep
  },
  props: {
    parent: String
  },
  data () {
    return {
      depData: {},
      currentStep: 0,
      orgParent: '',
      stepLabel: [
        this.$t('orgs.subdivision_data'),
        this.$t('orgs.info_org'),
        this.$t('orgs.data_confirmation')
      ]
    }
  },
  methods: {
    next () {
      if (++this.currentStep > 3) this.currentStep = 0;
    },
    prev () {
      if (--this.currentStep < 0) this.currentStep = 0;
    },
    setData (data) {
      this.depData = Object.assign(this.depData, data)
    },
    setPageTitle (name) {
      this.$emit('setPageTitle', name)
    },
    setOrgParent (parentId) {
      this.orgParent = parentId
    },
    resetPageTitle () {
      this.$emit('resetPageTitle')
    },
    async sendData () {
      try {
        await this.$store.dispatch('orgs/createOrg', this.depData)
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.success'),
          message: this.$t('orgs.subdivision_added'),
          type: 'success',
          offset: 75
        })
        this.currentStep = 0
        this.reset()
        this.depData = {}
        this.$root.$emit('resetScroll')
        this.$router.push({name: 'orgs'})
      } catch (error) {
        console.error('error in department create', error)
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.error'),
          message: this.$t('orgs.can_not_add_org'),
          type: 'error',
          offset: 75
        })
      }
      /* try {
        let data = JSON.parse(JSON.stringify(this.depData))
        if (data.services.list) {
          for (let index in data.services.list) {
            data.services.list[index] = {id: data.services.list[index]._id}
          }
        }
        let result = await org.create(this.orgParent)
        console.log('ORG CREATE', result);
        org.update(result.doc_id, data).then(result => {
          console.log('ORG UPDATE', result);
          this.$notify({
            // @ts-ignore
title: this.$t('labels.success'),
            message: this.$t('orgs.subdivision_added'),
            type: 'success',
            offset: 75
          })
          this.currentStep = 0
          this.reset()
          this.depData = {}
        })
        this.$root.$emit('resetScroll')
      } catch (e) {
        console.error('error in department create', e)
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.error'),
          // @ts-ignore
          message: this.$t('orgs.can_not_add_subdivision'),
          type: 'error',
          offset: 75
        })
      } */
    },
    reset () {
      this.resetPageTitle();
      this.orgParent = '';
      this.$refs.firstStep.resetData();
      this.$refs.secondStep.resetData();
    }
  }
}
</script>
<style lang="scss">
  @import 'src/assets/sass/core';

  .dep-create {
    border-radius: $global-radius;
    overflow: hidden;
    &__nav-buttons {
      .el-button {
        margin-right: 10px;
        margin-bottom: 10px;
      }

      .el-button + .el-button {
        margin-left: 0;
        margin-top: 0;
      }
    }
  }

  .dep-create-steps-desktop {
    padding: 25px;
    background: #fff;

    @media only screen and (max-width: $screen-sm) {
      display: none;
    }

    .el-step__title {
      max-width: 150px;
      line-height: 1.3;
      margin-right: 5px;
      @media only screen and (max-width: $screen-sm) {
        font-size: 12px;
      }
    }
  }

  .dep-create-steps-mobile {
    padding: 25px 0;
    background: #fff;
    margin: 0;
    overflow: hidden;

    &__container {
      position: relative;
      height: 130px;

      &:before,
      &:after {
        content: '';
        position: absolute;
        z-index: 2;
        top: 0;
        width: 50px;
        height: 100%;
      }

      &:before {
        left: 0;
        background: linear-gradient(
          to right,
          #fff,
          rgba(255, 255, 255, 0.9),
          rgba(255, 255, 255, 0.8),
          rgba(255, 255, 255, 0.7),
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0.5),
          rgba(255, 255, 255, 0.4),
          rgba(255, 255, 255, 0.3),
          rgba(255, 255, 255, 0.2),
          rgba(255, 255, 255, 0.1),
          rgba(255, 255, 255, 0)
        );
      }

      &:after {
        right: 0;
        background: linear-gradient(
          to left,
          #fff,
          rgba(255, 255, 255, 0.9),
          rgba(255, 255, 255, 0.8),
          rgba(255, 255, 255, 0.7),
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0.5),
          rgba(255, 255, 255, 0.4),
          rgba(255, 255, 255, 0.3),
          rgba(255, 255, 255, 0.2),
          rgba(255, 255, 255, 0.1),
          rgba(255, 255, 255, 0)
        );
      }
    }

    &__step {
      position: absolute;
      z-index: 1;
      top: 0;
      width: 100px;
      text-align: center;

      &--first {
        left: 0;
        color: #67c23a;
      }

      &--curent {
        font-weight: 700;
        left: 50%;
        transform: translateX(-50%);
      }

      &--last {
        right: 0;
      }
    }

    &__step-number {
      position: relative;
      z-index: 1;
      display: inline-block;
      line-height: 21px;
      width: 24px;
      height: 24px;
      margin: 0 auto;
      border: 2px solid;
      text-align: center;
      border-radius: 100%;
      font-size: 14px;
      font-weight: 700;
      background: #fff;
    }

    &__line {
      position: absolute;
      z-index: 0;
      top: 13px;
      height: 2px;
      width: 50%;
      background: #000;

      &--left {
        left: 0;
        background: #67c23a;
      }

      &--right {
        right: 0;
      }

      &.hide {
        display: none;
      }
    }

    &__step-label {
      margin-top: 10px;
      font-size: 12px;
    }

    @media only screen and (min-width: $screen-sm) {
      display: none;
    }
  }

  .dep-create-form {
    padding: 20px 25px;
    background: #fff;
    &__section {
      margin-bottom: 40px;
      .el-input,
      .el-textarea {
        margin-bottom: 30px;
      }
    }
    &--services {
      margin-top: 20px;
    }

    &__section-title {
      font-size: 20px;
      font-weight: bold;

      color: #000000;
      margin-bottom: 20px;
    }

    &__section-row {
      display: grid;
      grid-template-columns: 150px 1fr;
      grid-column-gap: 30px;
      padding: 7px 0;
      @include respond-to(phone) {
        grid-template-columns: 1fr;
      }
    }

    &__section-row-label {
      font-weight: 700;
    }

    &__section-table-container {
      overflow: auto;
    }

    &__section-table {
      min-width: 400px;
    }

    &__section-table-row {
      display: grid;
      grid-template-columns: 1fr 120px 120px;
      padding: 10px 5px;
      border-top: 1px solid #e4e4e4;
      grid-gap: 5%;
      &:last-child {
        border-bottom: 1px solid #e4e4e4;
      }
      @include respond-to(phone) {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }

    &__section-paragraph {
      white-space: pre-line;
      word-break: break-all;
    }

    &__field-error {
      font-size: 12px;
      color: #ff5151;
    }

    .el-select {
      min-width: 250px;
    }

    .el-button {
      margin-right: 10px;
    }

    .el-button + .el-button {
      margin-left: 0;
      margin-top: 0;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 15px;
      position: relative;
      z-index: 1;
    }

    /* Label */
    .el-input__prefix {
      left: 5px;
      top: -18px;
      font-size: 12px;
      opacity: 0;
      visibility: hidden;
    }

    .el-input,
    .el-select,
    .el-textarea {
      &.showLabel {
        .el-input__prefix {
          animation-name: showLabel;
          animation-duration: 0.5s;
          animation-direction: normal;
          animation-fill-mode: forwards;
          animation-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
        }
      }
    }

    @keyframes showLabel {
      0% {
        visibility: visible;
        opacity: 0;
        transform: translateX(50px);
      }
      100% {
        visibility: visible;
        opacity: 1;
        transform: translateX(0);
      }
    }

    /* Erors */
    .el-input,
    .el-select {
      &.error {
        .el-input__inner {
          border-color: #ff5151;
          position: relative;
          z-index: 1;
        }

        .label-error {
          color: #ff5151;
        }
      }

      &.valid {
        .el-input__inner {
          border-color: #09d200;
          position: relative;
          z-index: 1;
        }

        label {
          color: #09d200;
        }
      }
    }
  }
</style>